<script setup>
import { useMapGetter } from 'dashboard/composables/store';
import { ref } from 'vue';

import EmptyStateLayout from 'dashboard/components-next/EmptyStateLayout.vue';
import CreateNewContactDialog from 'dashboard/components-next/Contacts/ContactsForm/CreateNewContactDialog.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import ContactsCard from 'dashboard/components-next/Contacts/ContactsCard/ContactsCard.vue';
import contactContent from 'dashboard/components-next/Contacts/EmptyState/contactEmptyStateContent';

defineProps({
  title: {
    type: String,
    default: '',
  },
  subtitle: {
    type: String,
    default: '',
  },
  showButton: {
    type: Boolean,
    default: true,
  },
  buttonLabel: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['create']);

const createNewContactDialogRef = ref(null);

const onClick = () => {
  createNewContactDialogRef.value?.dialogRef.open();
};
const assignedOnly = useMapGetter('isAssignedOnly');
</script>

<template>
  <div
    v-if="assignedOnly"
    class="flex flex-1 flex-col items-center justify-center gap-3 p-8 text-center"
  >
    <span
      class="i-lucide-contact-round size-10 text-n-slate-9"
      aria-hidden="true"
    />
    <h2 class="text-lg font-medium text-n-slate-12">
      {{ $t('AGENT_MGMT.ASSIGNED_ONLY_EMPTY_TITLE') }}
    </h2>
    <p class="text-sm text-n-slate-11">
      {{ $t('AGENT_MGMT.ASSIGNED_ONLY_EMPTY_DESCRIPTION') }}
    </p>
  </div>
  <EmptyStateLayout v-else :title="title" :subtitle="subtitle">
    <template #empty-state-item>
      <div class="grid grid-cols-1 gap-4 p-px overflow-hidden">
        <ContactsCard
          v-for="contact in contactContent.slice(0, 5)"
          :id="contact.id"
          :key="contact.id"
          :name="contact.name"
          :email="contact.email"
          :thumbnail="contact.thumbnail"
          :phone-number="contact.phoneNumber"
          :additional-attributes="contact.additionalAttributes"
          :is-expanded="0 === contact.id"
          @toggle="toggleExpanded(contact.id)"
        />
      </div>
    </template>
    <template #actions>
      <div v-if="showButton && !assignedOnly">
        <Button :label="buttonLabel" icon="i-lucide-plus" @click="onClick" />
        <CreateNewContactDialog
          ref="createNewContactDialogRef"
          @create="emit('create', $event)"
        />
      </div>
    </template>
  </EmptyStateLayout>
</template>
